import { ref } from 'vue';
import { defineStore } from 'pinia';

// Definimos las constantes para los filtros
export const SHIPMENT_FILTERS = {
  TOTAL: 'TOTAL_SHIPMENTS',
  IN_TRANSIT: 'IN_TRANSIT',
  DELAYED: 'DELAYED',
  ADVANCED: 'ADVANCED',
  COMPLETED: 'COMPLETED',
  DEPARTED: 'DEPARTED',
  ARRIVED: 'ARRIVED'
};

export const useShipmentStatsStore = defineStore('shipmentStats', () => {
  // state
  const activeFilters = ref(new Set());
  
  // actions
  const toggleFilter = (filter: string) => {
    if (activeFilters.value.has(filter)) {
      activeFilters.value.delete(filter);
    } else {
      activeFilters.value.add(filter);
    }
  }
  
  const clearFilters = () => {
    activeFilters.value.clear();
  }
  
  return {
    activeFilters,
    toggleFilter,
    clearFilters
  };
});